export const environment = {
  version: "1052-manual",
  production: false,
  region: "ap-southeast-2",
  endpoint: "https://api.dev.surveyor.digitalp.com.au",
  logLevel: "silly",
  buildId: process.env.NG_APP_BUILD_ID || "local",
  defaultCollectionLimit: 10,
  enableServiceWorker: false,
  enableSentry: true,
  sentryEnvironment: "dev",
  sentryTracesSampleRate: 0.1,
  sentryReplayMaskAllText: false,
  sentryReplayMaskAllInputs: false,
  sentryReplayBlockAllMedia: false,
  sentryReplaySessionSampleRate: 0,
  sentryReplayOnErrorSampleRate: 1,
  timeZone: "Australia/Brisbane",
  defaultAuthEmail: "",
  defaultAuthPassword: "",
  defaultDateTimeFormat: "dd MMM yyyy hh:mma",
  defaultDateFormat: "dd MMM yyyy",
  defaultShortDateFormat: "dd/MM/yyyy",
  siteDomain: "dev.surveyor.digitalp.com.au",
  secureCookies: true,
  autoSaveDebounceWaitTimeFormTemplate: 5000, // Time in milliseconds to wait after the last change before auto-saving and user has stopped making changes
  autoSaveDebounceWaitTimeFormGroup: 30000, // Time in milliseconds to wait after the last change before auto-saving and user has stopped making changes
  autoSaveWaitTimeFormTemplate: 30000, // Time in milliseconds to wait before auto-saving after changes have made while the user is still making changes
  borderColour: "red",
  featureFlags: {
    autoSave: true,
    formTemplatePreview: true,
    formTemplateValidation: true,
    versionChecking: false,
    reportBuilder: true,
    userAccessControl: false,
  },
};
